import styled from 'styled-components';

export const StyledScrollTrigger = styled.div`
  position: relative !important;
  display: block !important;
  width: 0 !important;
  height: 0 !important;
  box-sizing: border-box !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
`;
